module.exports = __webpack_public_path__ + "static/media/21ECLAC10.a81cd038.jpg";